var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useSite } from '../hooks/use-site';
import { MenuItem } from './menu-item';
import { TextBubble } from './text-bubble';
import { usePlatformUrl } from '../hooks/use-platform-url';
import { useAuth } from '../hooks/use-auth';
import { useUserMenu } from '../hooks/use-user-menu';
import { LoginIconGlyph, LogoutIconGlyph, PersonIconGlyph, TeamIcon } from '@shapeable/icons';
import { useLang } from '../hooks/use-lang';
import { SiteMenuTitle } from '../entities/site-menu-title';
import { useEnv } from '../hooks/use-env';
import { useApp } from '../hooks/use-app';
import { useReady } from '../hooks/use-ready';
var cls = classNames('lang-menu');
export var UserMenuDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-size: 1em;\n  "], ["\n    width: 100%;\n    font-size: 1em;\n  "]))),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
});
var TextBubbleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled(MenuItem)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  TextBubble: styled(TextBubble)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), TextBubbleStyles)
};
/* @ts-ignore */
export var UserMenu = React.forwardRef(function (props, ref) {
  var className = props.className,
    onItemClick = props.onItemClick,
    showTitle = props.showTitle;
  var platformUrl = usePlatformUrl();
  var auth = useAuth();
  var t = useLang();
  var app = useApp();
  var env = useEnv();
  var isReady = useReady().isReady;
  var _a = useUserMenu(),
    UserMenuTopItem = _a.userMenuTopItem,
    UserMenuBottomItem = _a.userMenuBottomItem,
    hideLogout = _a.hideLogout;
  // console.log("USER MENU COMPONENT", Component);
  var _b = useSite(),
    platformLoginLabel = _b.platformLoginLabel,
    loginLabel = _b.loginLabel,
    logoutLabel = _b.logoutLabel,
    showPlatformLogin = _b.showPlatformLogin;
  var handleLogoutClick = function (e) {
    if (onItemClick) {
      onItemClick(e);
    }
    auth.logout();
  };
  var handleLoginClick = function (e) {
    if (onItemClick) {
      onItemClick(e);
    }
    auth.login();
  };
  var title = auth.isAvailable && auth.isAuthenticated ? auth.user.givenName : t('Login');
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, showTitle && React.createElement(SiteMenuTitle, null, title), isReady && auth.isAvailable && (auth.isAuthenticated ? React.createElement(React.Fragment, null, UserMenuTopItem && React.createElement(UserMenuTopItem, null), !hideLogout && React.createElement(My.Item, {
    onClick: handleLogoutClick,
    iconComponent: LogoutIconGlyph,
    label: logoutLabel
  }), app.includeProfile && React.createElement(My.Item, {
    href: app.profilePath,
    iconComponent: PersonIconGlyph,
    label: t('My Profile')
  }), UserMenuBottomItem && React.createElement(UserMenuBottomItem, null)) : React.createElement(My.Item, {
    onClick: handleLoginClick,
    iconComponent: LoginIconGlyph,
    label: loginLabel
  })), showPlatformLogin && platformUrl && React.createElement(My.Item, {
    onClick: onItemClick,
    iconComponent: TeamIcon,
    label: platformLoginLabel,
    href: platformUrl
  }));
});
UserMenu.cls = cls;
UserMenu.defaultProps = UserMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;